import http from "@/request"


/**
 * 单位用户数据
 * @param {*} data 
 * @returns 
 */
export function listUnitUser(data) {
    return http({
        url: "/baseUser/list",
        method: "post",
        data: data
    });
}


/**
 * 保存用户信息
 * @param {*} data 
 * @returns 
 */
export function saveUnitUser(data) {
    return http({
        url: "/baseUser/saveUnitUser",
        method: "post",
        data: data
    });
}

/**
 * 删除用户
 * @param {*} data 
 * @returns 
 */
export function deleteUnitUser(data) {
    return http({
        url: "/baseUser/deleteUnitUser",
        method: "post",
        data: data
    });
}


/**
 * 重置密码
 * @param {*} data 
 * @returns 
 */
export function resetUnitSystemPassword(data) {
    return http({
        url: "/baseUser/resetUnitSystemPassword",
        method: "post",
        data: data
    });
}



// WEBPACK FOOTER //
// ./src/api/unitUser.js